"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundPlayingState = void 0;
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
// eslint-disable-next-line no-shadow
var SoundPlayingState;
(function (SoundPlayingState) {
    SoundPlayingState[SoundPlayingState["PLAYING"] = 0] = "PLAYING";
    SoundPlayingState[SoundPlayingState["PAUSED"] = 1] = "PAUSED";
    SoundPlayingState[SoundPlayingState["NONE"] = 2] = "NONE";
})(SoundPlayingState || (exports.SoundPlayingState = SoundPlayingState = {}));
const buildCallableStartPlayingAudio = (audioInterface) => async ({ functionId, entryVars: { uri, }, callbacks, processor, executeProcesses, }) => {
    if (!(0, valueIsString_1.default)(uri) || uri === '') {
        processor.root.alert('Invalid uri to play audio', `${uri}`);
        return;
    }
    const state = await audioInterface.getState();
    const audioListeners = {
        onPlayTimeUpdate: (time) => {
            executeProcesses(functionId, callbacks.onPlayTimeUpdate, time);
        },
        onStopPlaying: () => {
            executeProcesses(functionId, callbacks.onStopPlaying);
        },
    };
    const startPlaying = async () => {
        await audioInterface.start(uri, audioListeners);
        executeProcesses(functionId, callbacks.onStartPlaying);
    };
    try {
        switch (state) {
            case SoundPlayingState.PLAYING:
                await audioInterface.stop();
                await startPlaying();
                break;
            case SoundPlayingState.PAUSED: {
                const playingUri = await audioInterface.getPlayingUri();
                if (playingUri === uri) {
                    await audioInterface.resume();
                }
                else {
                    await audioInterface.stop();
                    await startPlaying();
                }
                break;
            }
            default:
                await startPlaying();
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.onError, `${error}`);
    }
};
exports.default = buildCallableStartPlayingAudio;
